import { LoadingIcon } from '@chegg-ui/theme';
import dynamic from 'next/dynamic';
import React from 'react';
import { CUIIconSizes } from '../constants';
import { SourceType } from '../types';
import { LoaderWrapper } from './styled';

/** props inteface for every form component */

var CenterLoader = function CenterLoader() {
  return /*#__PURE__*/React.createElement(LoaderWrapper, null, /*#__PURE__*/React.createElement(LoadingIcon, {
    size: CUIIconSizes.MEDIUM
  }));
};

/** forms importing */
export var BookForm = dynamic(function () {
  return import('./book');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var DigitalFileForm = dynamic(function () {
  return import('./digital-file');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var DigitalImageForm = dynamic(function () {
  return import('./digital-image');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var DissertationThesisForm = dynamic(function () {
  return import('./dissertation-thesis');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var DissertationAbstractForm = dynamic(function () {
  return import('./dissertation-abstract');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var FilmOnlineVideoForm = dynamic(function () {
  return import('./film-online-video');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var GovernmentPublicationForm = dynamic(function () {
  return import('./govt-publication');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var OnlineDatabaseForm = dynamic(function () {
  return import('./online-database');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var JournalForm = dynamic(function () {
  return import('./journal');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var WebSiteForm = dynamic(function () {
  return import('./website');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var EditorialForm = dynamic(function () {
  return import('./editorial');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ReviewForm = dynamic(function () {
  return import('./review');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var InterviewForm = dynamic(function () {
  return import('./interview');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var TvRadioForm = dynamic(function () {
  return import('./tv-radio');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ReportForm = dynamic(function () {
  return import('./report');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ScholarlyProjectForm = dynamic(function () {
  return import('./scholarly-project');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MiscellaneousForm = dynamic(function () {
  return import('./miscellaneous');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var LetterForm = dynamic(function () {
  return import('./letter');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var LectureForm = dynamic(function () {
  return import('./lecture');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MultivolumeForm = dynamic(function () {
  return import('./multivolume');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MusicalRecordingForm = dynamic(function () {
  return import('./musical-recording');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MagazineNewspaperForm = dynamic(function () {
  return import('./magazine-newspaper');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MicroForm = dynamic(function () {
  return import('./microform');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MailingListForm = dynamic(function () {
  return import('./mailing-list');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var MapForm = dynamic(function () {
  return import('./map');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var NewsgroupForm = dynamic(function () {
  return import('./newsgroup');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var NewsletterForm = dynamic(function () {
  return import('./newsletter');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var PhotoForm = dynamic(function () {
  return import('./photo');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var BlogForm = dynamic(function () {
  return import('./blog');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var CourtCaseForm = dynamic(function () {
  return import('./courtcase');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var PressForm = dynamic(function () {
  return import('./press');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var BibleForm = dynamic(function () {
  return import('./bible');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ConferenceForm = dynamic(function () {
  return import('./conference');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var AdvertisementForm = dynamic(function () {
  return import('./advertisement');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var BrochureForm = dynamic(function () {
  return import('./brochure');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var PaintingForm = dynamic(function () {
  return import('./painting');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var CartoonForm = dynamic(function () {
  return import('./cartoon');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var CongressForm = dynamic(function () {
  return import('./congress');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var DictionaryForm = dynamic(function () {
  return import('./dictionary');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var EncyclopediaForm = dynamic(function () {
  return import('./encyclopedia');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var EmailForm = dynamic(function () {
  return import('./email');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ExecutiveOrderForm = dynamic(function () {
  return import('./executive-order');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var FederalBillForm = dynamic(function () {
  return import('./federal-bill');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var FederalReportForm = dynamic(function () {
  return import('./federal-report');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var FederalRuleForm = dynamic(function () {
  return import('./federal-rule');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var FederalTestimonyForm = dynamic(function () {
  return import('./federal-testimony');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var FederalStatuteForm = dynamic(function () {
  return import('./federal-statute');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var PatentForm = dynamic(function () {
  return import('./patent');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var PerformanceForm = dynamic(function () {
  return import('./performance');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ManuscriptForm = dynamic(function () {
  return import('./manuscript');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var PamphletForm = dynamic(function () {
  return import('./pamphlet');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var RawDataForm = dynamic(function () {
  return import('./raw-data');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var WritePasteForm = dynamic(function () {
  return import('./write-paste');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var SoftwareForm = dynamic(function () {
  return import('./software');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});
export var ReprintedWorkForm = dynamic(function () {
  return import('./reprinted-work');
}, {
  loading: function loading() {
    return /*#__PURE__*/React.createElement(CenterLoader, null);
  }
});

/**
 * @param sourceType
 * @returns form for the sourceType passed with transformation functions
 */
export var getForm = function getForm(sourceType) {
  switch (sourceType) {
    case SourceType.BOOK:
      return BookForm;
    case SourceType.CHAPTER:
      return BookForm;
    case SourceType.DIGITAL_FILE:
      return DigitalFileForm;
    case SourceType.INTRODUCTION:
      return BookForm;
    case SourceType.DIGITAL_IMAGE:
      return DigitalImageForm;
    case SourceType.DISSERTATION:
    case SourceType.THESIS:
      return DissertationThesisForm;
    case SourceType.DISSERTATION_ABSTRACT:
      return DissertationAbstractForm;
    case SourceType.FILM_ONLINE_VIDEO:
      return FilmOnlineVideoForm;
    case SourceType.GOVERNMENT_PUBLICATION:
      return GovernmentPublicationForm;
    case SourceType.JOURNAL:
      return JournalForm;
    case SourceType.REVIEW:
      return ReviewForm;
    case SourceType.INTERVIEW:
      return InterviewForm;
    case SourceType.TV_RADIO:
      return TvRadioForm;
    case SourceType.ONLINE_DATABASE:
      return OnlineDatabaseForm;
    case SourceType.EDITORIAL:
      return EditorialForm;
    case SourceType.PHOTO:
      return PhotoForm;
    case SourceType.MAGAZINE:
    case SourceType.NEWSPAPER:
      return MagazineNewspaperForm;
    case SourceType.MICROFORM:
      return MicroForm;
    case SourceType.BLOG:
      return BlogForm;
    case SourceType.COURTCASE:
      return CourtCaseForm;
    case SourceType.PRESS:
      return PressForm;
    case SourceType.REPORT:
      return ReportForm;
    case SourceType.ADVERTISEMENT:
      return AdvertisementForm;
    case SourceType.SCHOLARLY_PROJECT:
      return ScholarlyProjectForm;
    case SourceType.MISCELLANEOUS:
      return MiscellaneousForm;
    case SourceType.LETTER:
      return LetterForm;
    case SourceType.LECTURE:
      return LectureForm;
    case SourceType.MULTIVOLUME:
      return MultivolumeForm;
    case SourceType.MUSICAL_RECORDING:
      return MusicalRecordingForm;
    case SourceType.BROCHURE:
      return BrochureForm;
    case SourceType.BIBLE:
      return BibleForm;
    case SourceType.CONFERENCE:
      return ConferenceForm;
    case SourceType.PAINTING:
      return PaintingForm;
    case SourceType.CARTOON:
      return CartoonForm;
    case SourceType.CONGRESS:
      return CongressForm;
    case SourceType.DICTIONARY:
      return DictionaryForm;
    case SourceType.ENCYCLOPEDIA:
      return EncyclopediaForm;
    case SourceType.EMAIL:
      return EmailForm;
    case SourceType.EXECUTIVE_ORDER:
      return ExecutiveOrderForm;
    case SourceType.FEDERAL_BILL:
      return FederalBillForm;
    case SourceType.FEDERAL_REPORT:
      return FederalReportForm;
    case SourceType.FEDERAL_RULE:
      return FederalRuleForm;
    case SourceType.MAILING_LIST:
      return MailingListForm;
    case SourceType.MAP:
      return MapForm;
    case SourceType.NEWSGROUP:
      return NewsgroupForm;
    case SourceType.NEWSLETTER:
      return NewsletterForm;
    case SourceType.FEDERAL_TESTIMONY:
      return FederalTestimonyForm;
    case SourceType.FEDERAL_STATUTE:
      return FederalStatuteForm;
    case SourceType.PATENT:
      return PatentForm;
    case SourceType.PAMPHLET:
      return PamphletForm;
    case SourceType.RAW_DATA:
      return RawDataForm;
    case SourceType.PERFORMANCE:
      return PerformanceForm;
    case SourceType.WRITE_PASTE:
      return WritePasteForm;
    case SourceType.MANUSCRIPT:
      return ManuscriptForm;
    case SourceType.SOFTWARE:
      return SoftwareForm;
    case SourceType.REPRINTED_WORK:
      return ReprintedWorkForm;
    case SourceType.WEBSITE:
    default:
      return WebSiteForm;
  }
};

/** ======= tranformation functions ======== */

/**
 * @param citation incoming initialCitationState
 * @returns equivalent form state - to initialize form context
 */
export var citationToFormStateTransformation = function citationToFormStateTransformation(citation) {
  var _citation$data$pubtyp, _citation$data$pubtyp2;
  /** basic setup for form state */
  var formState = {
    source: citation.data.source,
    pubtype: citation.data.pubtype,
    contributors: citation.contributors,
    annotation: citation.annotation
  };
  /** collecting pub info section data */
  var pubTypeMain = (_citation$data$pubtyp = citation.data.pubtype) === null || _citation$data$pubtyp === void 0 ? void 0 : _citation$data$pubtyp.main;
  var pubTypeSuffix = (_citation$data$pubtyp2 = citation.data.pubtype) === null || _citation$data$pubtyp2 === void 0 ? void 0 : _citation$data$pubtyp2.suffix;
  if (pubTypeMain) {
    formState[pubTypeMain] = citation.data[pubTypeMain];
  }
  if (pubTypeSuffix) {
    formState[pubTypeSuffix] = citation.data[pubTypeSuffix];
  }
  /** collecting citing section data, if any */
  if (citation.data[citation.data.source]) {
    formState[citation.data.source] = citation.data[citation.data.source];
  }
  /** collecting DOI data, if present */
  if (citation.data.doi) {
    formState.doi = citation.data.doi;
  }
  return formState;
};

/**
 * @param state form state
 * @returns equivalent GQL citation
 */
export var formStateToCitationTransformation = function formStateToCitationTransformation(state) {
  /** citation data intialized with basic info */
  var citation = {
    contributors: state.contributors,
    annotation: state.annotation,
    data: {
      source: state.source,
      pubtype: state.pubtype,
      annotation: state.annotation
    }
  };
  /** adding pub info section data */
  var pubTypeMain = citation.data.pubtype.main;
  var pubTypeSuffix = citation.data.pubtype.suffix;
  if (pubTypeMain) {
    citation.data[pubTypeMain] = state[pubTypeMain];
  }
  if (pubTypeSuffix) {
    citation.data[pubTypeSuffix] = state[pubTypeSuffix];
  }
  /** collecting citing section data, if any */
  if (state[state.source]) {
    citation.data[state.source] = state[state.source];
  }
  /** collecting DOI data, if present */
  if (state.doi) {
    citation.data.doi = state.doi;
  }
  return citation;
};